import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

const handleHrWidth = (length) => {
  switch (length) {
    case 'large':
      return '90%'
    case 'medium':
      return '50%'
    default:
      return '10%'
  }
}

interface StyledSeparatorProps {
  theme: any;
  $length: any;
  $themeCustom: any;
}
export const StyledSeparator = styled.div<StyledSeparatorProps>`
  width: ${({ $length }) => handleHrWidth($length)};
  margin: ${pxToRem(20)} auto;
  border-bottom: ${({ theme }) => pxToRem(theme.separator_height || 1)}
  ${({ theme }) => theme.separator_style || 'solid'}
  ${({ theme, $themeCustom }) => $themeCustom ? $themeCustom.details.colors.separators : theme.separator_color || theme.text_color || 'lightgray'};
  height: ${({ theme }) => pxToRem(theme.separator_height || 1)};
  border-radius: ${({ theme }) => pxToRem(theme.separator_radius || 1)};
`

